/**
 * Throttling function for expensive events
 * @param {Function} cb - callback function to execute in specified intervals
 * @param {Number} interval - interval in miliseconds in which the callback executes
 */
export const throttle = (cb, interval) => {
    let timeout;
    return function () {
        const context = this, args = arguments;
        const later = function () {
            timeout = false;
        };
        if (!timeout) {
            cb.apply(context, args);
            timeout = true;
            setTimeout(later, interval);
        }
    }
}

/**
 * Fire cb just once - after series of events starts or ends
 * @param {Function} cb - callback function to execute
 * @param {Number} interval - wait for a specified interval after the series of events end before cb execution
 * @param {Boolean} immediate - execute immediately when the series of events start
 * @returns 
 */
export const debounce = (cb, interval, immediate) => {
    var timeout;

    return function executedFunction() {
        var context = this;
        var args = arguments;

        var later = function () {
            timeout = null;
            if (!immediate) cb.apply(context, args);
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, interval);

        if (callNow) cb.apply(context, args);
    };
};